import { Card, CardBody, Col, Row } from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { JOB_DATA } from "../../../../Data/JobSearch";
import { H4, Image, P, Ribbon } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { SimilarjobsCardsType } from "../../../../Type/JobSearch";
import { dynamicImage } from "../../../../Service/DynamicImage";

const SimilarjobsCards = ({limit,jobClass,ribbion,col12}: SimilarjobsCardsType) => {
  return (
    <Row>
      {JOB_DATA.slice(0, 5).map((item) => (
        <Col
          className={`col-auto ${limit === item.id && col12? "col-xl-12 xl-100": jobClass}`} key={item.id}>
          <Card className={`${item.ribbion && ribbion ? "ribbon-vertical-left-wrapper" : ""}`}>
            {item.ribbion ? (
              <Ribbon className={`ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary ${!ribbion && "d-none"}`}>
                <i className="icofont icofont-love"></i>
              </Ribbon>
            ) : (" ")}
            <div className="job-search">
              <CardBody>
                <div className="d-flex">
                  <Image width="40" height="40"  className="img-40 b-r-0 img-fluid m-r-20" src={dynamicImage(`${item.logo}`)} alt=""/>
                  <div className="flex-grow-1">
                    <H4>
                      <Link to={`${process.env.PUBLIC_URL}/apps/job/job-details`}>{item.job_name}</Link>
                      {item.type === "new" ? (<span className="badge badge-primary pull-right">{item.badgeValue}</span>) : 
                      (<span className="pull-right">{item.type}</span>)}
                    </H4>
                    <P>
                      {item.job_area}, {item.job_city}
                      <Rating className="rating ms-1" fillColor="#feb858" initialValue={Math.random() * 5} size={14}/>
                    </P>
                  </div>
                </div>
                <P>{item.Job_description}</P>
              </CardBody>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default SimilarjobsCards;
